export default __webpack_public_path__ + "static/media/close_ham.5e432910.svg";